import ACTIONS from "../../constants/constants"

export const products = (state = {}, action)=>{
    switch(action.type){
        case ACTIONS.ADD_PRODUCT_ARRAY:
            return {...action.payload}
        default:
            return state    
    }
}